import { BLACK_300, MEDIUM_BLUE } from 'constants/colors';

export const getDataZoomConfig = (
  zoomStart: number,
  zoomEnd: number,
  yAxisIndex: number | number[] = 0,
  hideZoomSlider = false,
) => [
  {
    type: 'slider' as const,
    show: false,
    xAxisIndex: 0,
    filterMode: 'none' as const,
    start: zoomStart,
    end: zoomEnd,
  },
  {
    type: 'slider' as const,
    show: !hideZoomSlider,
    yAxisIndex,
    right: '5%',
    start: 0,
    end: 100,
    filterMode: 'none' as const,
    borderRadius: 32,
    width: 8,
    borderColor: BLACK_300, // tema: cor de dado
    fillerColor: MEDIUM_BLUE, // tema: cor de dado
    showDetail: false,
    showDataShadow: false,
    handleIcon: 'path://m50,50 a100,100 0 1,0 -200,0 a 100,100 0 1,0 200,0 Z',
    handleSize: 14,
    handleStyle: {
      borderColor: MEDIUM_BLUE, // tema: cor de dado
      borderWidth: 2,
    },
    moveHandleStyle: {
      opacity: 0,
    },
    brushSelect: false,
    brushStyle: {
      opacity: 0,
    },
    dataBackground: {
      lineStyle: {
        opacity: 0,
      },
      areaStyle: {
        opacity: 0,
      },
    },
  },
];

export const getXAxisConfig = () => ({
  type: 'time' as const,
  splitNumber: 10,
  minInterval: 24 * 3600 * 1000,
  axisLine: {
    onZero: false,
  },
  axisLabel: {
    showMaxLabel: true,
    formatter: '{d}/{M}/{yy}',
    rotate: 45,
    margin: 10,
    fontWeight: 'bold',
  },
});
